import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { StaffService } from "./Shared/staff.service";
import { CommonmastersService } from "../commonmasters/commonmasters.service";
import { DateAdapter } from '@angular/material';
import { environment } from '../../environments/environment';
// import { Formatteddate } from "./../helpers/formatteddate";
import { dateFormatPipe } from './../helpers/formatteddate';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.css'],
  providers: [StaffService]
})

export class StaffComponent implements OnInit {

  // count: number = 0;
  // @Output() countChange = new EventEmitter();

  staff: any;
  AreaList: any[] = [];
  RegionList: any[] = [];
  BranchList: any[] = [];
  DesignationList: any[] = [];
  AddButtonText: string;
  ErrorText: string;
  StaffNo: number;
  readonlyTextBox: boolean = false;
  imgURL: any = null;
  EmployeePhotoName: any = null;

  PhotoName: any = null;
  imgPhotoURL: any = null;
  selectedPhotoFile: File = null;
  formData: FormData;
  formatDate: dateFormatPipe;
  selectedFile: any ;
  ImageType: any;

  constructor(private router: Router, private route: ActivatedRoute,
    public staffService: StaffService,
    private commonmastersService: CommonmastersService,
  ) {
    this.formData = new FormData();
    this.formatDate = new dateFormatPipe();
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.StaffNo = +  params['Id'];  // (+) converts string 'id' to a number
    });

    this.resetForm();
    this.GetBranch();
    this.GetDesignation();

    if (Number.isNaN(this.StaffNo)) {
      this.staffService.selectedEmployee.Id = 0;
      this.staffService.selectedEmployee.Flag = 1;
      this.staffService.selectedEmployee.IsActive = true;
      this.readonlyTextBox = false;
      this.AddButtonText = "Save";
    }
    else {
      this.staffService.selectedEmployee.Id = +this.StaffNo;
      this.staffService.selectedEmployee.Flag = 2;
      this.staffService.selectedEmployee.IsActive = true;
      this.readonlyTextBox = true;
      this.AddButtonText = "Edit";

      this.GetStaffByStaffId();
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
    this.staffService.selectedEmployee = {
      Id: 0,
      Code: '',
      Name: '',
      MName: '',
      LName: '',
      UserName: '',
      Password: '',
      BranchId: 0,
      Email: '',
      FromDate: null,
      ToDate: null,
      Default: false,
      PhoneNo: '',
      Education: 4,
      Gender: 2,
      DOB: null,
      JoiningDate: null,
      TerminationDate: null,
      CreatedDate: null,
      ModifiedDate: null,
      SaasId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      IsActive: true,
      Flag: null,

      Salutation: "Mrs.",
      PresentAddress: null,
      PermanentAddress: null,
      PhotoName: null,
      Mobile: null,
      Mobile2: null,
      PersonalEmail: null,
      ManagerId: 0,
      RoleId: 0,
      IsStaffMaster: 0,
      PhotoFilePath: null,
    }
  }

  // fileProgress(fileInput: any) {
  //   this.fileData = <File>fileInput.target.files[0];
  //   console.log("fileProgress");
  //   console.log(this.fileData);
  // }

  onFileChanged(event) {
    // Get the file selected.
    // const selectedFile = event.target.files[0];
    this.selectedFile = event.target.files[0];
    this.EmployeePhotoName = this.selectedFile.name;

    // changing the file name and appending the file type to it ie, selectedFile.type
    let EmployeeNo: string = this.staffService.selectedEmployee.Id.toString();
    this.ImageType = event.target.files[0].type.split("/"); // getting file extension 
    this.formData.append('PhotoFile', event.target.files[0], EmployeeNo + "." + this.ImageType[1]);

    // To display the selected image before deciding to upload it.
    let reader = new FileReader();

    // Gets a 'base64' representation of an image.
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = (event2) => {
      // Sets the html <img> tag to the image.
      this.imgURL = reader.result;
    };

    // console.log("onFileChanged");
    // console.log(selectedFile);
    // console.log(selectedFile.name);
  }

  onSubmit(form: NgForm) {

    // if (form.value.UserName != null) {
    form.value.PhotoName = form.value.UserName + "_" + this.EmployeePhotoName;
    
    const retVal= this.IUDStaff(form)
    if(retVal != 0){
      // this.UploadFiles(data.ResponseId);
      this.router.navigate(['/stafflist']);
    }
    
    // this.staffService.IUDStaff(form.value)
    //   .subscribe(data => {
    //     this.uploadFiles(data.ResponseId);
    //     this.router.navigate(['/stafflist']);
    //   })
    // }
  }

  GetBranch() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  GetBranchId(BranchId: number) {
    // console.log(BranchId ); 
    // console.log("BranchId  Here!");
  }

  GetDesignation() {
    this.commonmastersService.GetDesignationList().subscribe(data => {
      this.DesignationList = data;
    })
  }

  onDate(date: any) {
    // console.log(this.staffService.selectedStaff.FromDate);
    // console.log("date reached ---");
  }

  updateCount() {
    // this.count = this.count + 1;
    // this.countChange.emit(this.pageName);
  }

  pageName: string = "Staff Master"
  BreadCrumName() {
    return this.pageName;
  }

  // Edit Section
  GetStaffByStaffId() {
    if (this.staffService.selectedEmployee.Id !== 0) {
      this.staffService.FetchStaffbyId(this.staffService.selectedEmployee).subscribe(data => {

        this.staffService.selectedEmployee.Id = data.Id;
        this.staffService.selectedEmployee.Code = data.Code;
        this.staffService.selectedEmployee.UserName = data.UserName;
        this.staffService.selectedEmployee.Name = data.Name;
        this.staffService.selectedEmployee.MName = data.MName;
        this.staffService.selectedEmployee.LName = data.LName;
        this.staffService.selectedEmployee.Email = data.Email;
        this.staffService.selectedEmployee.BranchId = data.BranchId;
        this.staffService.selectedEmployee.Default = data.Default;
        this.staffService.selectedEmployee.PhoneNo = data.PhoneNo;
        this.staffService.selectedEmployee.Education = data.Education;
        this.staffService.selectedEmployee.DOB = this.formatDate.getMMDDYYYY(data.DOB);
        this.staffService.selectedEmployee.JoiningDate = this.formatDate.getMMDDYYYY(data.JoiningDate);
        this.staffService.selectedEmployee.TerminationDate = this.formatDate.getMMDDYYYY(data.TerminationDate);

        this.staffService.selectedEmployee.IsActive = data.IsActive;
        // image binding
        this.imgURL = environment.baseUrl + data.PhotoFilePath;

        // console.log(environment.baseUrl + data.PhotoFilePath);
      })
    }
  }

  // uploadPhoto(event) {
  //   // Get the file selected.

  //   const selectedFile = event.target.files[0];
  //   this.selectedPhotoFile = event.target.files[0];
  //   this.PhotoName = selectedFile.name;

  //   // changing the file name and appending the file type to it ie, selectedFile.type
  //   let CustomerNo : string = this.staffService.selectedEmployee.Id.toString();
  //   let ImageType = event.target.files[0].type.split("/"); // getting file extension 
  //   this.formData.append('PhotoFile', event.target.files[0], CustomerNo + "." + ImageType[1]);

  //   // To display the selected image before deciding to upload it.
  //   let reader = new FileReader();

  //   // Gets a 'base64' representation of an image.
  //   reader.readAsDataURL(event.target.files[0]);

  //   reader.onload = (event2) => {
  //     // Sets the html <img> tag to the image.
  //     this.imgPhotoURL = reader.result;
  //   };

  // }


  // employeeFiles: EmployeeFiles = {
  //   Id :this.staffService.selectedEmployee.Id,
  //   EmployeeNo: this.staffService.selectedEmployee.Id,
  //   PhotoFileName :this.PhotoName,  
  //   PhotoFilePath: this.imgPhotoURL 
  //   // IdProofFileName:string;  
  //   // IdProofFilePath: string;
  //   // AddressProofFilePath: string;
  //   // EmployeeBranchId: number;
  //   // CompanyId: number;
  //   // SaasId: string;
  //   // CreatedDate: Date;
  //   // ModifiedDate: Date;
  //   // IsActive  : boolean;
  //   // Flag : number;

  // }

  // Uploading the files based on the StaffId after save 
  
  UploadFiles(EmployeeId : number) {

    this.formData.delete('PhotoFile'); // removing the existing PhotoFile.
    this.formData.append('PhotoFile',  this.selectedFile, EmployeeId + "." + this.ImageType[1]);
    this.staffService.IUDStaffFiles(this.formData)
      .subscribe(data => {
        // this.resetForm(form);
      });
  }

  IUDStaff(form: NgForm): any {

    return new Promise<boolean>((resolve, reject) => {

      this.staffService.IUDStaff(form.value)
        .toPromise()
        .then(data => {

                if (data !== null) {
                    console.log(data[0].ResponseId)
                    this.UploadFiles(data[0].ResponseId);
                    return data.ResponseId;
                }
                else {
                    return 0;
                }
            })
            .catch(err => {
                console.log(err)
                return 0;
            });

        resolve(false);
    });
  }

}
